import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function ChessPawn({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  colliders = "trimesh",
  type = "fixed",
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/Chess Piece/PrimaryWhitePawn_007.glb");
  const pawnScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    pawnScene.traverse((child) => {
      if (child instanceof THREE.Mesh || child instanceof THREE.SkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [pawnScene]);

  return (
    <RigidBody
      type={type}
      colliders={colliders}
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={pawnScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/Chess Piece/PrimaryWhitePawn_007.glb");
